var _defs, _rect, _text, _circle, _rect2, _path, _circle2, _circle3, _circle4, _rect3, _rect4, _rect5, _rect6, _rect7, _circle5, _rect8, _circle6, _path2, _path3, _rect9, _rect0, _rect1, _rect10, _polyline, _rect11, _polygon, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _rect12, _rect13, _path17, _path18, _line, _line2, _line3, _text2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g2, _path31, _path32, _path33, _rect14, _rect15, _path34, _path35, _line4, _line5, _line6, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiuxdesign6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-13,.cls-16,.cls-21,.cls-22,.cls-4{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-14,.cls-3{fill:#2f2143;}.cls-4{stroke:#9a499c;stroke-width:2px;}.cls-13,.cls-16,.cls-21,.cls-22,.cls-4{stroke-miterlimit:10;}.cls-5{fill:#c79ec9;}.cls-6{fill:#a777b3;}.cls-7{fill:#8b56a3;}.cls-8{fill:#9a499b;}.cls-23,.cls-9{fill:#2d1f44;}.cls-10{fill:#ece0ec;}.cls-11{fill:#322549;}.cls-12{fill:#e5ac24;}.cls-13{stroke:#fff;stroke-width:2.71px;}.cls-15{fill:#faac6d;}.cls-16{stroke:#263238;stroke-width:1.33px;}.cls-16,.cls-21,.cls-22{stroke-linecap:round;}.cls-17{clip-path:url(#clip-path);}.cls-18{fill:#fff;}.cls-19{fill:#e4a328;}.cls-20,.cls-27{fill:#fdc435;}.cls-21{stroke:#d18653;}.cls-21,.cls-22{stroke-width:0.89px;}.cls-22{stroke:#d58f5e;}.cls-23{font-size:60px;}.cls-23,.cls-27{font-family:Anta-Regular, Anta;}.cls-24{fill:#263238;}.cls-25{clip-path:url(#clip-path-2);}.cls-26{fill:#2d1f42;}.cls-27{font-size:52.31px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.85,105.59s1.56-4.4,2.49-5.21a24.57,24.57,0,0,1-10-4.16s-3.58,7.34,7.49,9.37"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1481.54,105.5s-1.55-4.4-2.48-5.21a24.62,24.62,0,0,0,10-4.16s3.57,7.34-7.5,9.37"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ui ux design 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1600,
    height: 326
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(551.69 185.35)"
  }, "UI/UX DESIGN")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 86.26,
    cy: 284.11,
    r: 19.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 559.26,
    y: 26.48,
    width: 448.7,
    height: 84.49,
    rx: 15.21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M559.84,37.53l447.54.08a17.11,17.11,0,0,0-4-7.16c-6-6.2-15.78-4.92-17.83-4.73-13.22,1.23-178.23,1-407.8.14a15.42,15.42,0,0,0-12.2,3A17.11,17.11,0,0,0,559.84,37.53Z",
    transform: "translate(0 0)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 573.77,
    cy: 32.71,
    r: 3.58
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 584.76,
    cy: 32.71,
    r: 3.58
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 595.69,
    cy: 32.71,
    r: 3.58
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 572.83,
    y: 50.52,
    width: 417.65,
    height: 9.61,
    rx: 4.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 572.83,
    y: 68.16,
    width: 122.66,
    height: 6.05,
    rx: 3.03
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 572.83,
    y: 85.25,
    width: 122.66,
    height: 6.05,
    rx: 3.03
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 940.6,
    y: 71.04,
    width: 47.97,
    height: 28.43,
    rx: 11.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1031.97,
    y: 27.73,
    width: 46.03,
    height: 17.11,
    rx: 8.56
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1041.03,
    cy: 36.47,
    r: 6.32
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 498.22,
    y: 102.7,
    width: 45.44,
    height: 16.89,
    rx: 8.45,
    transform: "translate(1041.87 222.3) rotate(-180)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 534.71,
    cy: 111.33,
    r: 6.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M578.35,250.91h-.05a21.6,21.6,0,0,0-.23-6.77h0l3.06-4.21-2.12-4.7-5.18-.48,0,0a21.62,21.62,0,0,0-5-4.63l0,0-.82-5.13-4.82-1.82-4,3.32v0a21.59,21.59,0,0,0-6.77.24v0l-4.21-3.05-4.69,2.12-.49,5.18,0,0A21.62,21.62,0,0,0,538.5,236v0l-5.14.82-1.82,4.82,3.32,4h0a21.61,21.61,0,0,0,.23,6.77h0l-3.06,4.21,2.12,4.69,5.18.48,0,0a21.84,21.84,0,0,0,5,4.63h0l.82,5.14,4.82,1.82,4-3.33v0a21.9,21.9,0,0,0,6.77-.23v0l4.21,3.06,4.69-2.12.49-5.19,0,0a21.62,21.62,0,0,0,4.63-4.95h0l5.14-.81,1.82-4.82Zm-5.3,3.59a17.59,17.59,0,1,1-10.22-22.68,17.6,17.6,0,0,1,10.22,22.68",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M101.87,86h-.05a22.33,22.33,0,0,0-.24-7h0l3.15-4.34-2.19-4.83-5.34-.5,0,0a22.29,22.29,0,0,0-5.1-4.77l0,0-.84-5.29-5-1.87-4.13,3.42v0a22.63,22.63,0,0,0-7,.24v0l-4.34-3.15L66,60.12l-.5,5.34,0,0a22.5,22.5,0,0,0-4.77,5.1h0l-5.3.84-1.87,5,3.42,4.13h0a22.26,22.26,0,0,0,.24,7h0l-3.15,4.34,2.19,4.84,5.34.49,0,0a22.73,22.73,0,0,0,5.1,4.77h0l.84,5.3,5,1.87,4.12-3.43v0a22.34,22.34,0,0,0,7-.24v0L88,108.53l4.84-2.19.5-5.34,0,0a22.52,22.52,0,0,0,4.77-5.1v0l5.3-.84,1.87-5Zm-5.46,3.7A18.13,18.13,0,1,1,85.88,66.28,18.14,18.14,0,0,1,96.41,89.65",
    transform: "translate(0 0)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1106.19,
    y: 175.08,
    width: 23.02,
    height: 26.78
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1141.4,
    y: 163.15,
    width: 20.57,
    height: 38.71
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1177.81,
    y: 142.96,
    width: 20.57,
    height: 58.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1215.47,
    y: 123.7,
    width: 20.57,
    height: 78.16
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "1107.52 168.23 1128.09 168.23 1141.4 153.56 1161.96 153.56 1173.16 137.76 1198.38 137.76 1213.91 117.57 1236.04 117.57"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 909.74,
    y: 239.85,
    width: 54.85,
    height: 44.01,
    rx: 11.53
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "927.81 252.04 927.81 272.39 950.11 262.21 927.81 252.04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M225.12,62.49s.86-1.29,6.09,6.24c0,0,.84-6.54-4.29-9.18s-1.8,2.94-1.8,2.94",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M239.7,326c0-14.34-.08-16.37-.08-16.37l9.8,16.37c7.27.2,43.62,0,54.12,0-17.92-40-37.14-76.07-37.14-76.07l-.57-9.67L188,245.85c-3.07,15.48-.65,49.36,2.52,80.15C207.12,326,223.26,325.92,239.7,326Z",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M346.22,192.9l.78-13.59,8.56-.19s1.82-3.6,4.82-4.64c0,0,7.28-4.95,9-4.73,0,0,1.8.43-3.2,6.79,0,0-2.24,2.67,6.89,2.44,0,0,15.11.46,10.31,3.61,0,0,12.72,3-8.61,3.72q12.72.62,12.78,1.85t-11.39,2.89s6.17,0,6.8,1.37c0,0,2.44,1.87-6.61,1.85,0,0-11.32.9-18.33-2.08l-11.45.69",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M227,147.39s-9.18-7.93-29.29-12.74c0,0,9.06-9.07-.89-39.54L220.16,111s-2.84,18.45,9.64,19.29c0,0-.05,12.17-2.83,17.08",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M218,118.89s-19.7,1.69-24.17-16.48c0,0-5.41-19.59-3.68-25.84s2.06-10.93,10.11-16.45,19-4.49,26.47,2.91a36.08,36.08,0,0,1,8.72,17.42s3.72,20.82-1.59,27.34c0,0-5.47,10.32-15.86,11.1",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M200.11,88.83a6.41,6.41,0,0,1-1.14-4,67.37,67.37,0,0,1,2.71-12.19s.14-3.32-3.82-5.52c0,0,5-7.64,15.59-3.14,0,0,5.62,3.46,11.11-2.07,0,0,6.32-7-1.08-12.29,0,0-2.39-2-15.85-1,0,0-35.12,3.33-27.85,17.23,0,0-5.62,5.45,1.19,18.81,0,0,5.23,11,14.22,8.81,0,0,7-1,4.92-4.68",
    transform: "translate(0 0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M197.13,100.54s-2.53,1.54-7.42-1.72c0,0-10.66-7.17-3.64-14.34,0,0,8.83-6,14.17,9.37,0,0,.84,5.53-3.11,6.69",
    transform: "translate(0 0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M216.16,84.27c.14,1.66-.66,3.09-1.78,3.18s-2.15-1.18-2.29-2.84.66-3.09,1.79-3.19,2.14,1.18,2.28,2.85",
    transform: "translate(0 0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M231.16,81.25c.14,1.66-.66,3.09-1.78,3.18s-2.15-1.18-2.29-2.84.66-3.09,1.78-3.19,2.15,1.18,2.29,2.85",
    transform: "translate(0 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M207.67,80.14s4.16-5.78,9.4-2.29",
    transform: "translate(0 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M223.92,77.06s4.16-5.78,9.4-2.29",
    transform: "translate(0 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M219.86,105.59s1.55-4.4,2.48-5.21a24.57,24.57,0,0,1-10-4.16s-3.58,7.34,7.5,9.37",
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M212.36,96.22v1.72S217,101.5,220,101.5l1.46-1.28",
    transform: "translate(0 0)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M223.92,85.65a74.88,74.88,0,0,1,6,8.59l-.77,0a64.29,64.29,0,0,1-6.79-.43,67.08,67.08,0,0,1,6.79-.43l-.37.66a73.33,73.33,0,0,1-4.84-8.37",
    transform: "translate(0 0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M188.05,248.27l-1.35-36S153.92,143,174.77,133.91l21.85-4.64,5.4-8.86,16.41,7.17,1.11-6.47,7,5.38s11.12.77,16.68,2.78c0,0,19.64,9.61,55.12,45.56l49.15,3.59,1.86,16.11-58.23,1.72s-13.49-5.31-36.73-26.58L261.53,206l4.27,36.55Z",
    transform: "translate(0 0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.19,133.27l1.49-5.3,2.73-.82,4.13,3-1.4,6.74s22.54,33.3,29.42,102.88L246.8,252l-15.72-9.85S238.9,217.11,219,139Z",
    transform: "translate(0 0)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 278.29,
    y: 139.51,
    width: 88.6,
    height: 79.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 284.44,
    y: 145.02,
    width: 76.3,
    height: 68.29
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M270.87,226.69s-3.93-11.24-.68-17.88l-62.55-8.45s-14.72-65.63-32.87-64.84c0,0-21.82,4.28,11.91,78.27,0,0,0,9.16,29,10Z",
    transform: "translate(0 0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M273.62,209.92v-6.38s-6.16,1.27-6.2,10.92c0,0,.32,11.43,3.53,14.53,0,0,5,3.69,15.7-.28,0,0,.93-3-7.51-2,0,0,9.88.4,10.55-2.18,0,0,1.12-3.51-11.53-2.53,0,0,12.28,1,11.9-2.07,0,0,.55-2.38-5-2.63l-5.77-.7s9.7,2,8.93-1.4c0,0,.89-2.86-14.56-5.28",
    transform: "translate(0 0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 279.68,
    y1: 226.66,
    x2: 284.1,
    y2: 226.66
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 278.29,
    y1: 221.99,
    x2: 285.94,
    y2: 221.99
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 279.25,
    y1: 216.6,
    x2: 284.76,
    y2: 217.27
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(292.1 201.99)"
  }, "UI")), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1476.28,62.4s-.86-1.29-6.1,6.24c0,0-.84-6.54,4.29-9.18s1.81,2.94,1.81,2.94",
    transform: "translate(0 0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1461.69,325.91c0-14.34.09-16.38.09-16.38l-9.8,16.38c-7.28.2-43.63,0-54.13,0,17.92-40,37.14-76.07,37.14-76.07l.58-9.67,77.85,5.59c3.07,15.48.65,49.36-2.51,80.15C1494.27,325.9,1478.13,325.83,1461.69,325.91Z",
    transform: "translate(0 0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1355.17,192.81l-.78-13.59-8.56-.19s-1.81-3.6-4.82-4.64c0,0-7.28-4.95-9-4.73,0,0-1.8.43,3.2,6.79,0,0,2.25,2.67-6.89,2.44,0,0-15.11.46-10.3,3.61,0,0-12.72,3,8.61,3.72q-12.72.61-12.78,1.85t11.39,2.89s-6.18,0-6.81,1.37c0,0-2.44,1.87,6.62,1.85,0,0,11.31.9,18.32-2.08l11.46.69",
    transform: "translate(0 0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1474.42,147.3s9.19-7.93,29.3-12.74c0,0-9.07-9.07.88-39.54l-23.37,15.91s2.84,18.45-9.63,19.29c0,0,.05,12.17,2.82,17.08",
    transform: "translate(0 0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1483.37,118.8s19.7,1.69,24.17-16.48c0,0,5.4-19.59,3.67-25.84s-2.06-10.93-10.1-16.45-19-4.49-26.48,2.91a36,36,0,0,0-8.71,17.42s-3.73,20.82,1.59,27.34c0,0,5.47,10.32,15.86,11.1",
    transform: "translate(0 0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1501.28,88.74c.09-.34.34-.51.65-1.18a5.71,5.71,0,0,0,.49-2.8,67.37,67.37,0,0,0-2.71-12.19s-.14-3.32,3.83-5.52c0,0-5-7.64-15.6-3.14a16.23,16.23,0,0,1-5.42,1,16.57,16.57,0,0,1-7.89-2,8.68,8.68,0,0,1,2.63-17.16,26.62,26.62,0,0,1,5-1.56,28.36,28.36,0,0,1,14.87,1c14.63,2.5,24.89,8.9,25.44,16a9,9,0,0,1-.91,4.57A10.22,10.22,0,0,1,1526,70.3c2.32,4.93,0,12.06-6.26,17.22a24,24,0,0,1-3.1,2.31,25.07,25.07,0,0,1-10.48,3.59C1501.88,90.89,1501.08,89.52,1501.28,88.74Z",
    transform: "translate(0 0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1504.26,100.45s2.53,1.54,7.42-1.72c0,0,10.66-7.17,3.64-14.34,0,0-8.82-6-14.17,9.37,0,0-.83,5.53,3.11,6.69",
    transform: "translate(0 0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1485.23,84.18c-.14,1.66.66,3.09,1.79,3.18s2.14-1.18,2.28-2.84-.66-3.09-1.78-3.19-2.15,1.18-2.29,2.85",
    transform: "translate(0 0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1470.23,81.16c-.14,1.66.66,3.09,1.79,3.18s2.15-1.18,2.28-2.84-.66-3.09-1.78-3.19-2.15,1.18-2.29,2.85",
    transform: "translate(0 0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1493.73,80.05a16.68,16.68,0,0,0-4.48-2.51,6.28,6.28,0,0,0-2.37-.28,12,12,0,0,0-2.56.5,4.92,4.92,0,0,1,2.38-1.53,5.08,5.08,0,0,1,2.94,0,6.51,6.51,0,0,1,2.49,1.47A6.13,6.13,0,0,1,1493.73,80.05Z",
    transform: "translate(0 0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1477.48,77a16.68,16.68,0,0,0-4.48-2.51,6.28,6.28,0,0,0-2.37-.28,12,12,0,0,0-2.56.5,4.92,4.92,0,0,1,2.38-1.53,5.08,5.08,0,0,1,2.94,0,6.51,6.51,0,0,1,2.49,1.47A6.13,6.13,0,0,1,1477.48,77Z",
    transform: "translate(0 0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1481.54,105.5s-1.55-4.4-2.48-5.21a24.48,24.48,0,0,0,10-4.17s3.58,7.35-7.49,9.38",
    transform: "translate(0 0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1489,96.13v1.72s-4.63,3.56-7.66,3.56l-1.45-1.28",
    transform: "translate(0 0)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1477.48,85.56a75,75,0,0,0-6,8.59l.78,0a64.28,64.28,0,0,0,6.78-.43,67.07,67.07,0,0,0-6.78-.43l.36.66a74.92,74.92,0,0,0,4.85-8.37",
    transform: "translate(0 0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1513.35,248.18l1.34-36s32.79-69.22,11.93-78.32l-21.84-4.64-5.41-8.86-16.4,7.16-1.11-6.46-7,5.38s-11.12.77-16.67,2.78c0,0-19.64,9.61-55.13,45.56l-49.15,3.59-1.85,16.11,58.22,1.72s13.49-5.31,36.73-26.59l-7.14,36.37-4.27,36.55Z",
    transform: "translate(0 0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1486.2,133.18l-1.48-5.3-2.74-.82-4.13,3,1.4,6.74s-22.53,33.3-29.42,102.88l4.76,12.26,15.72-9.85s-7.81-25.08,12.11-103.18Z",
    transform: "translate(0 0)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1334.5,
    y: 139.42,
    width: 88.6,
    height: 79.3,
    transform: "translate(2757.61 358.14) rotate(-180)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1340.66,
    y: 144.93,
    width: 76.3,
    height: 68.29,
    transform: "translate(2757.61 358.14) rotate(-180)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1430.53,226.6s3.93-11.24.67-17.88l62.55-8.45s14.73-65.63,32.88-64.84c0,0,21.81,4.28-11.92,78.27,0,0,0,9.16-29,10Z",
    transform: "translate(0 0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1427.77,209.83v-6.38s6.16,1.27,6.2,10.92c0,0-.32,11.43-3.52,14.53,0,0-5,3.69-15.71-.28,0,0-.93-3,7.51-2,0,0-9.88.4-10.55-2.18,0,0-1.12-3.51,11.53-2.53,0,0-12.27,1-11.9-2.07,0,0-.55-2.38,5.05-2.63l5.77-.7s-9.71,2-8.94-1.4c0,0-.88-2.86,14.56-5.28",
    transform: "translate(0 0)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1421.72,
    y1: 226.57,
    x2: 1417.29,
    y2: 226.57
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1423.11,
    y1: 221.9,
    x2: 1415.45,
    y2: 221.9
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1422.15,
    y1: 216.51,
    x2: 1416.63,
    y2: 217.18
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-27",
    transform: "translate(1344.24 198.07)"
  }, "UX")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiuxdesign6);
export default __webpack_public_path__ + "static/media/Ui ux design 6.a6e8218c27c20d1f49a2c686ac59517b.svg";
export { ForwardRef as ReactComponent };